import { Card, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useWhiteLabeling from "../hooks/useWhiteLabeling";

const CompanyCard = (props) => {
    
    const [imageUrl, setImageUrl] = useState(null);
    const { fetchWhiteLabelingImageData } = useWhiteLabeling();
    const showReadMore = Array.isArray(props.data?.companyInfo?.content) &&
        props.data.companyInfo.content.length > 0;
    const hasLogoAsset = props.data?.brandingSettings?.logo_asset_id !== undefined &&
        props.data?.brandingSettings?.logo_asset_id !== null &&
        parseInt(props.data?.brandingSettings?.logo_asset_id) !== 0;
    
    const fetchLogoData = async (props) => {
        const imageUrl = await fetchWhiteLabelingImageData(props.data?.brandingSettings?.logo_asset_id);
        setImageUrl(imageUrl);
    }

    const handleClick = () => {
        if (showReadMore) {
            props.onClick();
        }
    }
    
    useEffect(() => {
        void fetchLogoData(props);
    }, [props.data]);
    
    return (
        <>
            <Card
                className={`no-rounding-bottom  no-box-shadow d-none d-sm-block ${showReadMore ? 'clickable' : ''}`}
                onClick={ handleClick }
            >
                <Card.Body>
                    {hasLogoAsset && (
                        <img src={ imageUrl } alt="Company Logo" className="mb-3" width={props.logoWidth} height={props.logoHeight} />
                    )}
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="text-break" id="heading-company-card-title">
                            { props.companyname }
                        </h3>
                        {showReadMore && (
                            <span className='float-end' aria-hidden="true"><FontAwesomeIcon icon={ far.faChevronRight } /></span>
                        )}
                    </div>
                </Card.Body>
            </Card>
            <Col xs={ 12 } className={ 'ps-3 pe-3 ps-md-4 pe-sm-4 col-10 d-sm-none' }>
                { hasLogoAsset && (
                    <img src={ imageUrl } alt="Company Logo" className="company-logo" width={props.logoWidth} height={props.logoHeight} />
                )}
                <div
                    className={`d-flex justify-content-between align-items-center ${props.onClick !== undefined ? 'clickable' : ''}`}
                    onClick={handleClick}
                    onKeyDown={ (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            handleClick()
                        }
                    }}
                >
                    <h3 className='text-break'>{ props.companyname }</h3>
                    {showReadMore && (
                        <span className='float-end' aria-hidden="true"><FontAwesomeIcon icon={ far.faChevronRight } /></span>
                    )}
                </div>
            </Col>
        </>
    );
}

CompanyCard.propTypes = {
    'companyname': PropTypes.string,
    'data': PropTypes.object,
    'logoWidth': PropTypes.number,
    'logoHeight': PropTypes.number,
    'onClick': PropTypes.func
}

export default CompanyCard;